import { motion } from "framer-motion";

type Props = {
  label: string;
};

const NavbarAnimatedText = ({ label }: Props) => {
  return (
    <motion.p
      initial={{ opacity: 0, y: -10 }}
      animate={{
        opacity: 1,
        y: -2,
      }}
      transition={{ duration: 0.1 }}
      className="absolute bottom-0 w-full text-center text-xs font-semibold text-customWhite"
    >
      {label}
    </motion.p>
  );
};

export default NavbarAnimatedText;
